<template>
  <div class="gift-information__container white-back-container">
    <div class="white-back-container__content">
      <div class="gift-information__header white-back-container__header">
        <h3 class="subhead-bold">
          お届けするギフト
        </h3>
      </div>
      <div class="white-back-container__inner-content">
        <TicketConnected
          :image-url="imageUrl"
          :item-name="itemName"
          :item-sku-name="itemSkuName"
          :brand-name="brandName"
          :expired-date="expiredDate"
        />
        <div class="gift-description__container">
          <div class="description" v-html="descriptionHtml" /><!-- eslint-disable-line -->
          <SmallLoading v-if="isLoadingTicketDescriptionHtml" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketConnected from '../../../../atoms/tickets/TicketConnected'
import SmallLoading from '../../../../atoms/loadings/SmallLoading'
export default {
  components: { SmallLoading, TicketConnected },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    expiredDate: {
      type: String,
      required: true
    },
    descriptionHtml: {
      type: String,
      required: true
    },
    isLoadingTicketDescriptionHtml: {
      type: Boolean,
      required: true
    }
  }
}
</script>
